import { ComponentsOverrides, Theme } from "@mui/material";
import { ciCustomColors } from "./colors";

type MuiAccordion = {
  styleOverrides: ComponentsOverrides<Theme>["MuiAccordion"];
};

const muiAccordion: MuiAccordion = {
  styleOverrides: {
    root: {
      border: `1.5px solid ${ciCustomColors.blue[50]}`,
      borderRadius: "5px",
      boxShadow: "none",
      "&:before": {
        display: "none",
      },

      "& .MuiAccordionSummary-root": {
        minHeight: "40px",
        "&.MuiAccordionSummary-gutters": {
          padding: "8px 16px",
        },
      },
      "& .MuiAccordionSummary-content": {
        margin: "0",
      },
    },
  },
};

export default muiAccordion;
